import { css } from 'styled-components';
import { themeGradient, themeSize, themeColorWithOpacity } from './getters';
import { GradientAnimation } from './keyframes';

export const fillAbsolute = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const objectFitEdge = css`
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
`;

export const noTapSelection = css`
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
`;

export const centerAbsolute = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const contentPadding = css`
  padding-left: ${themeSize('contentPadding')}px;
  padding-right: ${themeSize('contentPadding')}px;
`;

export const square = size => css`
  width: ${size};
  height: ${size};
`;

export const animatedPlaceholder = css`
  color: transparent;
  background-clip: border-box;
  background-image: ${themeGradient('primary')};
  background-size: 400% 400%;
  animation: ${GradientAnimation} 2s ease infinite;
`;

export const secondaryAnimatedPlaceholder = css`
  ${animatedPlaceholder};
  background-image: ${themeGradient('secondary')};
`;

export const getUnderLine = (color = 'primary') => css`
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: ${themeColorWithOpacity(color, 0.2)};
`;
